import { useEffect, useId, useRef } from 'react'

import { HOW_IT_WORKS, TRUST_LINE } from '../../lib/assistantCopy'

/**
 * "How the assistant works" (agent-1.md Appendix A, C41; DRAFT until O2): the
 * right column of `/assistant`, and a sheet from the drawer's footer.
 */
export function HowItWorks({ headingId }: { headingId?: string }) {
  return (
    <div className="assistant-how">
      <h2 className="assistant-how__title eyebrow" id={headingId}>
        How the assistant works
      </h2>
      <dl className="assistant-how__list">
        {HOW_IT_WORKS.map((block) => (
          <div key={block.head} className="assistant-how__item">
            <dt>{block.head}</dt>
            <dd>{block.body}</dd>
          </div>
        ))}
      </dl>
      <p className="assistant-how__trust">{TRUST_LINE}</p>
    </div>
  )
}

/** The same, as a modal sheet over the drawer. */
export function HowItWorksDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null)
  const headingId = useId()

  useEffect(() => {
    const dialog = ref.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    else if (!open && dialog.open) dialog.close()
    return () => {
      if (dialog.open) dialog.close()
    }
  }, [open])

  return (
    <dialog ref={ref} className="assistant-how-dialog" aria-labelledby={headingId} onClose={onClose}>
      {open && (
        <>
          <HowItWorks headingId={headingId} />
          <form method="dialog" className="assistant-how-dialog__actions">
            <button type="submit" className="btn btn--ghost btn--sm">
              Close
            </button>
          </form>
        </>
      )}
    </dialog>
  )
}
